import React from 'react';
import { connect } from 'react-redux';

import type { NavigationLocationState } from 'app/modules/Navigation/types';
import type { ReduxState } from 'app/redux/types';

import { currentLocation } from 'app/modules/Navigation/selectors';
import ErrorBoundary from 'app/widgets/ErrorBoundary';
import NotFound from 'app/widgets/Errors/NotFound';

import { MatchCenter } from '../MatchCenter';
import { Sport } from '../Sport';
import { SportRedirect } from '../SportRedirect';

type PrematchContentProps = Pick<
  NavigationLocationState,
  (
    'matchId' |
    'sportId' |
    'list'
  )
>;

const ContentWithoutHOC: React.FC<PrematchContentProps> = ({ list, sportId, matchId }) => {
  if (matchId) {
    return (
      <ErrorBoundary>
        <MatchCenter />
      </ErrorBoundary>
    );
  }

  if (sportId && !list) {
    return (
      <ErrorBoundary>
        <Sport sportId={sportId} />
      </ErrorBoundary>
    );
  }

  switch (list) {
    case null:
      return (
        <ErrorBoundary>
          <SportRedirect />
        </ErrorBoundary>
      );

    default:
      return <NotFound />;
  }
};

const mapStateToProps = (state: ReduxState): PrematchContentProps => {
  const location = currentLocation(state);

  return {
    list: location.list,
    sportId: location.sportId,
    matchId: location.matchId,
  };
};

export const Content = connect(mapStateToProps)(ContentWithoutHOC);
